<template>
    <div id="root" class="toggle-menu">
        <menu-component whiteFont="true"></menu-component>
        <b-row class="full-height bg-img">
            <b-container class="alinov-header center-text">
        <b-row>
          <b-col>
            <h1>Jarabes</h1>
                        <span>
                            Frase de dulzura
                        </span>
                        <br/><br>
            <a class="link-to-section" href="#syrups">
              <i class="fas fa-chevron-circle-down"></i>
            </a>
          </b-col>
        </b-row>
      </b-container>
            <div id="syrups" class="alinov-info-container">
                <b-container class="info">
                    <b-row class="title">
                        <b-col>
                            <h2>
                                ¿Utilizas el Piloncillo?
                            </h2>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p>
                            </p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="5">
                            <b-img :src="imgUrl" fluid />
                        </b-col>
                        <b-col cols="7">
                            <h3>
                                Jarabe de Piloncillo
                            </h3>
                            <p>
                            </p>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </b-row>
        <footer-component></footer-component>
    </div>
</template>

<script>
import Menu from "../shared/Menu.vue";
import Footer from '../shared/Footer.vue';
import $ from 'jquery'

export default {
  name: "Syrups",
  components: {
    "menu-component": Menu,
    'footer-component': Footer
    },
    beforeMount() {
        $(function() {
      $('a.link-to-section').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top-80}, 500, 'linear');
      });
    });

    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
            var headerHeight = 500;
            // $('.alinov-header').height() + 100;

      if (scroll >= headerHeight) {
                    $(".toggle-menu .alinov-navbar").addClass("white-bg");
                    $(".toggle-menu .alinov-navbar").removeClass("white-font");
      } else {
                $(".toggle-menu .alinov-navbar").removeClass("white-bg");
                $(".toggle-menu .alinov-navbar").addClass("white-font");
      }
    });
  },
  data() {
      return {
          imgUrl: require('@/assets/images/piloncillo.jpg')
      }
  }
};
</script>

<style lang="scss" scoped>
.full-height {
    background-image:linear-gradient( 
    rgba(0, 0, 0, 0.4), 
    rgba(0, 0, 0, 0.4) ), 
        url("../assets/images/syrup.jpg");
        background-position-y: 30%;
}

.alinov-info-container .info.container .row {
    h2 {
        font-size: 40px;
    }
}

.alinov-info-container .info.container .row.title {
    padding-top: 1rem;
}

.w-border {
    border-bottom: 1px solid rgba(0,0,0,0.1);
} 

.img-col .img-fluid {
    width: 80%;
}
</style>


